import React from "react";

const ThridColumn = props => {
	return (
		<div className="col-md-4 col-12 p-3 third-column">{props.children}</div>
	);
};

export default ThridColumn;
